import Columns from './columns';
import './columns.sass';

export default Columns;
